"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _selectInputNativeStyles = require("./select-input-native-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectInputNative = function SelectInputNative(_ref) {
  var options = _ref.options,
      value = _ref.value,
      placeholder = _ref.placeholder,
      multiSelection = _ref.multiSelection,
      getOptionLabel = _ref.getOptionLabel,
      getOptionValue = _ref.getOptionValue,
      optionSelected = _ref.optionSelected;

  var handleChangeMobile = function handleChangeMobile(e) {
    var obj = options.find(function (item) {
      return getOptionValue(item) == e.target.value;
    });
    if (obj) optionSelected(obj);
  };

  return /*#__PURE__*/_react.default.createElement(_selectInputNativeStyles.Container, {
    onChange: handleChangeMobile,
    placeholder: placeholder,
    defaultValue: getOptionValue(value),
    value: multiSelection ? "" : value ? getOptionValue(value) : ""
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("option", {
    value: null,
    hidden: true
  }, placeholder), options.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: getOptionLabel(item),
      value: getOptionValue(item)
    }, getOptionLabel(item));
  })));
};

var _default = SelectInputNative;
exports.default = _default;